export default {
  isNotNull: function isNotNull(data) {
    data = data || '';
    if (data.replace(/(^\s*)|(\s*$)/g, '').length == 0) {
      return false;
    } else {
      return true;
    }
  },
  isNull: function isNull(data) {
    data = data || '';
    if (data.replace(/(^\s*)|(\s*$)/g, '').length == 0) {
      return true;
    } else {
      return false;
    }
  },
  isObjNotNull: function isObjNotNull(data) {
    for (var key in data) {
      return true;
    };
    return false;
  }
};


// WEBPACK FOOTER //
// ./src/store/app.js